import type { ComponentType } from 'react';

import { FormToggleButtonRadioGroup } from '@ui/uikit/components/common/FormToggleButtonRadioGroup';

import { PredictionCards } from './PredictionCards/PredictionCards';
import { PredictionChart } from './PredictionsChart/PredictionChart';

export enum PredictionsTab {
  PREDICTION = 'PREDICTION',
  CHART = 'CHART',
}

const options = [
  {
    label: 'Prediction',
    value: PredictionsTab.PREDICTION,
  },
  {
    label: 'Chart',
    value: PredictionsTab.CHART,
  },
];

export const SelectedTabComponentMap: Record<PredictionsTab, ComponentType> = {
  [PredictionsTab.PREDICTION]: PredictionCards,
  [PredictionsTab.CHART]: PredictionChart,
};

type PredictionsTabsProps = {
  selectedTab: PredictionsTab;
  onChange: (selectedTab: PredictionsTab) => void;
};

export const PredictionsTabs = ({ selectedTab, onChange }: PredictionsTabsProps) => {
  return (
    <FormToggleButtonRadioGroup
      className="w-full md:w-auto bg-base-bg-secondary text-base-text-tertiary rounded-lg"
      options={options}
      value={selectedTab}
      onValueChange={(value: PredictionsTab) => onChange(value)}
    />
  );
};
